import React from 'react';
import Icon from '../../../components/AppIcon';

const PolicyTemplateLibrary = ({ policies, selectedPolicy, onPolicySelect, selectedCategory, onCategoryChange }) => {
  const categories = [
    { id: 'all', label: 'All Policies', icon: 'FileText', count: policies?.length },
    { id: 'leave', label: 'Leave & Time Off', icon: 'Calendar', count: policies?.filter(p => p?.category === 'leave')?.length },
    { id: 'payroll', label: 'Payroll & Wages', icon: 'DollarSign', count: policies?.filter(p => p?.category === 'payroll')?.length },
    { id: 'employment', label: 'Employment Terms', icon: 'Briefcase', count: policies?.filter(p => p?.category === 'employment')?.length },
    { id: 'benefits', label: 'Benefits', icon: 'Gift', count: policies?.filter(p => p?.category === 'benefits')?.length }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 h-full">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Library" size={20} color="var(--color-primary)" />
        <h3 className="font-heading font-semibold text-foreground">Policy Templates</h3>
      </div>
      {/* Category Filters */}
      <div className="mb-4 space-y-1">
        {categories?.map(category => (
          <button
            key={category?.id}
            onClick={() => onCategoryChange(category?.id)}
            className={`
              w-full flex items-center justify-between px-3 py-2 rounded-md transition-smooth
              ${
                selectedCategory === category?.id
                  ? 'bg-primary text-primary-foreground'
                  : 'bg-muted text-foreground hover:bg-muted/80'
              }
            `}
          >
            <div className="flex items-center gap-2">
              <Icon
                name={category?.icon}
                size={16}
                color={selectedCategory === category?.id ? 'currentColor' : 'var(--color-muted-foreground)'}
              />
              <span className="text-sm font-medium">{category?.label}</span>
            </div>
            <span className={`text-xs px-2 py-0.5 rounded-full ${
              selectedCategory === category?.id
                ? 'bg-primary-foreground/20 text-primary-foreground'
                : 'bg-muted-foreground/20 text-muted-foreground'
            }`}>
              {category?.count}
            </span>
          </button>
        ))}
      </div>
      {/* Policy List */}
      <div className="space-y-2 max-h-[600px] overflow-y-auto">
        {policies?.length === 0 ? (
          <div className="text-center py-8">
            <Icon name="Search" size={32} color="var(--color-muted-foreground)" className="mx-auto mb-2" />
            <p className="text-sm text-muted-foreground">No policies found</p>
          </div>
        ) : (
          policies?.map(policy => (
            <div
              key={policy?.id}
              onClick={() => onPolicySelect(policy)}
              className={`
                p-3 rounded-lg border-2 cursor-pointer transition-smooth
                ${
                  selectedPolicy?.id === policy?.id
                    ? 'border-primary bg-primary/5' :'border-border bg-card hover:border-muted-foreground hover:bg-muted/30'
                }
              `}
            >
              <div className="flex items-start justify-between mb-2">
                <h4 className="font-medium text-sm text-foreground">{policy?.name}</h4>
                {policy?.statutoryBaseline && (
                  <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-success/10 text-success text-xs rounded-full">
                    <Icon name="Shield" size={10} />
                    PNG Act
                  </span>
                )}
              </div>
              <p className="text-xs text-muted-foreground line-clamp-2">
                {policy?.description}
              </p>
              <div className="flex items-center gap-2 mt-2">
                <Icon name="Clock" size={12} color="var(--color-muted-foreground)" />
                <span className="text-xs text-muted-foreground">
                  Updated {policy?.lastUpdated}
                </span>
              </div>
            </div>
          ))
        )}
      </div>
      <div className="mt-4 p-3 bg-muted rounded-md">
        <div className="flex items-start gap-2">
          <Icon name="Info" size={14} color="var(--color-primary)" className="mt-0.5" />
          <p className="text-xs text-muted-foreground">
            All templates include PNG Employment Act 1978 statutory baselines. Customizable clauses can be adjusted above minimum requirements.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PolicyTemplateLibrary;